import { useTranslation } from "next-i18next";

import { IconStateZap } from "@/assets/icons/figma/IconStateZap";
import { ProductUnknown } from "@/common/contracts/product.contracts";
import { cn } from "@/common/utils/css.utils";

type BoostedLabelProps = {
  product?: ProductUnknown;
  className?: string;
};

export const BoostedLabel = ({ product, className }: BoostedLabelProps) => {
  const { t } = useTranslation();

  if (!product?.isBoosted) {
    return null;
  }

  return (
    <span
      className={cn(
        /* space-x rather than gap — flexbox gap is unsupported in older browsers. It only spaces
           element children, hence the span around the text. */
        "inline-flex items-center space-x-1 rounded-full bg-brand-500 px-2 py-0.5 font-title text-sm font-bold leading-6 text-white",
        className
      )}
    >
      <IconStateZap className="size-4 shrink-0" />
      <span>{t("boost-ad:ad-boosted-label")}</span>
    </span>
  );
};
